export const favorites = {
  title: "My Favorites",
  subtitle: "{{count}} saved homes",
  countries: "Countries",
  cities: "Cities",
  emptyTitle: "No favorites yet",
  emptyFiltered: "Try changing your filters to see your favorites.",
  emptyState:
    "Explore our unique homes and add them to your favorites to find them here.",
  noFavoritesYet: "No favorites yet",
  exploreMembersMap: "Explore the members map to find accommodations",
  exploreMap: "Explore the map",
  backToHome: "Back to home",
  howToAddFavorites: "How to add favorites?",
  step1: "Go to the",
  step2: "members map",
  step3: "and click the heart",
  step3End: "to add a property to your favorites",
  membersMapLink: "Members map",
  properties: "properties",
  selected: "selected",
  compare: "Compare",
  actions: "Actions",
  contact: "Contact",
  exchange: "Propose an exchange",
  removeFromFavorites: "Remove from favorites",
  removeFromComparison: "Remove from comparison",
  owner: "Owner",
  ratingLabel: "Rating",
  exchangesLabel: "Exchanges",
  exchangesCount: "exchanges",
  exchangesCompleted: "completed exchanges",
  capacityLabel: "Capacity",
  guestsCount: "guests",
  numberOfRooms: "rooms",
  roomsCount: "rooms",
  onlineStatus: "Online",
  onlineBadge: "Online",
  verifiedStatus: "Verified",
  verifiedBadge: "Verified",
  no: "No",
};
